module.exports = __webpack_public_path__ + "img/imgtaskjoin.c8e3c015.png";